import {
  Box,
  Button,
  Chip,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  selectClasses,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import GlobalCard from "../../../../components/GlobalCardComponent";
import AssessmentIcon from "@mui/icons-material/Assessment";
import SchoolIcon from "@mui/icons-material/School";
import PublicIcon from "@mui/icons-material/Public";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import InfoCard from "../../../../components/customPopup/InfoCard";

import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { G } from "@react-pdf/renderer";

export default function GradeComp() {
  const [value, setValue] = React.useState(0);
  const [selectedData, setSelectedData] = useState({
    id: 1,
    name: "Class 9 & 10",
  });
  const [classDetails, setClassDetails] = useState({});

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSelectedData(classes[newValue]);
  };

  const classes = [
    { id: 1, name: "Class 9 & 10" },
    { id: 2, name: "Class 11th" },
    { id: 3, name: "Class 12th" },
  ];

  useEffect(() => {
    switch (selectedData?.name) {
      case "Class 9 & 10":
        setClassDetails({
          className: "Class 9 & 10",
          heading: "Foundations & Preparation",
          cardItems: [
            {
              icon: <img src="/newdashboard/Grades/Vector (8).png" />,
              title: "Aptitude Assessments",
              description:
                "Identify strengths, interests & map potential career paths",
            },
            {
              icon: (
                <img
                  src="/newdashboard/Grades/Vector (9).png"
                  width="100%"
                  height="100%"
                />
              ),
              title: "University Selection",
              description:
                "Country-specific shortlisting based on ranking, budget & eligibility",
            },
            {
              icon: (
                <img
                  src="/newdashboard/Grades/Group (16).png"
                  width="100%"
                  height="100%"
                />
              ),
              title: "Scholarship Assistance",
              description:
                "Help with merit- or need-based funding applications",
            },
            {
              icon: (
                <img
                  src="/newdashboard/Grades/Vector (10).png"
                  width="100%"
                  height="100%"
                />
              ),
              title: "Visa & Pre-Departure Guidance",
              description:
                "Support with visa, accommodation, travel & cultural orientation",
            },
          ],
          growListHeading: "Kickstart",
          growList: [
            {
              icon: (
                <img src="/newdashboard/Grades/iconamoon_discover-bold.png" />
              ),
              title: "Discover Your Strengths Early On",
            },

            {
              icon: (
                <img src="/newdashboard/Grades/streamline-flex_decent-work-and-economic-growth-solid.png" />
              ),
              title: " Develop Skills For Future Success",
            },
            {
              icon: (
                <img src="/newdashboard/Grades/mynaui_academic-hat-solid.png" />
              ),
              title: "Excel in Academics And Beyond",
            },

            {
              icon: (
                <img src="/newdashboard/Grades/material-symbols_globe.png" />
              ),
              title: "Gain Early Global Study Exposure",
            },
          ],
        });
        break;
      case "Class 11th":
        setClassDetails({
          className: "Class 11th",
          heading: "Shape Your Path",
          cardItems: [
            {
              icon: (
                <img src="/newdashboard/Grades/material-symbols-light_map.png" />
              ),
              title: "Career Mapping",
              description:
                "Explore advanced career options based on interests and aptitude",
            },
            {
              icon: (
                <img
                  src="/newdashboard/Grades/leadership 1.png"
                  width="100%"
                  height="100%"
                />
              ),
              title: "Stream-Specific Guidance",
              description: "Personalized pathways for Science, Commerce, Arts.",
            },
            {
              icon: (
                <img
                  src="/newdashboard/Grades/mynaui_academic-hat-solid (1).png"
                  width="100%"
                  height="100%"
                />
              ),
              title: "Early Entrance Prep",
              description:
                "Start building a foundation for JEE, NEET, CLAT, SAT, etc.",
            },
            {
              icon: (
                <img
                  src="/newdashboard/Grades/streamline-ultimate_saving-bank-international-bold.png"
                  width="100%"
                  height="100%"
                />
              ),
              title: "International Pathways",
              description:
                "Early study abroad planning, subject alignment & eligibility.",
            },
          ],
          growListHeading: "Focus Ahead",
          growList: [
            {
              icon: (
                <img src="/newdashboard/Grades/material-symbols_social-leaderboard.png" />
              ),
              title: "Build Confidence & Leadership",
            },

            {
              icon: <img src="/newdashboard/Grades/eos-icons_project.png" />,
              title: " Internship & Project Exposure",
            },
            {
              icon: (
                <img src="/newdashboard/Grades/mynaui_academic-hat-solid (1).png" />
              ),
              title: "Strengthen Academics with Mentorship",
            },

            {
              icon: (
                <img src="/newdashboard/Grades/material-symbols-light_docs.png" />
              ),
              title: "Early Start on IELTS / SAT Prep",
            },
          ],
        });
        break;
      case "Class 12th":
        setClassDetails({
          className: "Class 12th",
          heading: "Your Next Step",
          cardItems: [
            {
              icon: <img src="/newdashboard/Grades/tabler_book-filled.png" />,
              title: "Board Exam Support",
              description: "Intensive subject-wise coaching & crash courses.",
            },
            {
              icon: (
                <img
                  src="/newdashboard/Grades/Vector (9).png"
                  width="100%"
                  height="100%"
                />
              ),
              title: "Entrance Exam Readiness",
              description: "Focused preparation for JEE, NEET, CLAT, CUET",
            },
            {
              icon: (
                <img
                  src="/newdashboard/Grades/material-symbols_globe.png"
                  width="100%"
                  height="100%"
                />
              ),
              title: "Overseas Admission Guidance",
              description:
                "Support with applications, essays, SOPs, and recommendations.",
            },
            {
              icon: (
                <img
                  src="/newdashboard/Grades/icon-park-solid_finance.png"
                  width="100%"
                  height="100%"
                />
              ),
              title: "Scholarships & Financial Aid",
              description:
                "Assistance with scholarships and education loan guidance.",
            },
          ],
          growListHeading: "Achievements",
          growList: [
            {
              icon: <img src="/newdashboard/Grades/mingcute_time-fill.png" />,
              title: "Time Management & Stress Handling",
            },

            {
              icon: (
                <img src="/newdashboard/Grades/material-symbols_globe.png" />
              ),
              title: "Unlock Global Study Opportunities",
            },
            {
              icon: (
                <img src="/newdashboard/Grades/mynaui_academic-hat-solid.png" />
              ),
              title: "Personalised College Counselling",
            },

            {
              icon: (
                <img src="/newdashboard/Grades/mingcute_performance-fill.png" />
              ),
              title: "Track Performance & Achieve Success",
            },
          ],
        });
        break;
      default:
        break;
    }
  }, [selectedData]);

  

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} textAlign="center">
          <Typography
            fontFamily="Inter"
            fontWeight={400}
            fontStyle="normal"
            fontSize="27px"
            color="#000000"
          >
            Select Your Grade
          </Typography>

          <Typography
            fontFamily="Inter"
            fontWeight={400}
            fontStyle="normal"
            fontSize="15px"
            color="#444444"
          >
            Choose your stage — foundation to admission
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Grid container justifyContent="center">
            <GlobalCard>
              <Tabs
                value={value}
                onChange={handleChange}
                variant="standard"
                TabIndicatorProps={{ style: { display: "none" } }} // Hide underline
                sx={{
                  fontFamily: "Inter",
                  minHeight: "30px",
                  height: "30px",
                  display: "flex",
                  gap: 22,
                  "& .MuiTabs-flexContainer": {
                    display: "flex",
                    gap: "16px", // adjust value as needed (e.g., '24px')
                  },
                  "& .MuiTab-root": {
                    textTransform: "none",
                    fontWeight: 400,
                    color: "#572575",
                    borderRadius: "8px",
                    minWidth: "180px",
                    minHeight: "30px",
                    height: "30px",
                  },
                  "& .MuiTab-root.Mui-selected": {
                    backgroundColor: "#572575",
                    color: "#FFFFFF",
                    fontWeight: 600,
                    boxShadow: "0 0 4px rgba(0,0,0,0.2)",
                  },
                }}
              >
                {classes?.map((item, index) => (
                  <Tab label={item?.name} key={index} />
                ))}
              </Tabs>
            </GlobalCard>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={7}>
              <GlobalCard height="100%">
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      alignItems="center"
                      flexWrap="wrap"
                      gap={1}
                    >
                      <Chip
                        label={classDetails?.className}
                        variant="contained"
                        style={{
                          fontFamily: "Inter",
                          fontSize: "13px",
                          fontWeight: 600,
                          backgroundColor: "#9D03851A",
                          color: "#9D0385",
                        }}
                      />
                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontSize: "18px",
                          fontWeight: 400,

                          fontStyle: "normal",

                          color: "#9D0385",
                        }}
                      >
                        {classDetails?.heading}
                      </Typography>
                    </Box>
                  </Grid>
                  {classDetails?.cardItems?.map((item) => (
                    <Grid item xs={12} sm={12} md={6}>
                      <InfoCard height="100%">
                        <Box
                          display="flex"
                          flexDirection="column"
                          justifyContent="center"
                          alignItems="center"
                        >
                          <Box display="flex" alignItems="flex-start" gap={1}>
                            {/* ICON */}
                            <Box height={20} width={25}>
                              {item.icon}
                            </Box>

                            {/* Text Content: Title + Subtitle */}
                            <Box display="flex" flexDirection="column">
                              <Typography
                                fontFamily="Inter"
                                fontWeight={400}
                                fontStyle="normal"
                                fontSize="14px"
                                color="#000000"
                              >
                                {item.title}
                              </Typography>

                              <Typography
                                fontFamily="Inter"
                                fontWeight={400}
                                fontStyle="normal"
                                fontSize="12px"
                                color="#444444"
                                mt={0.3}
                              >
                                {item.description}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      </InfoCard>
                    </Grid>
                  ))}
                </Grid>
              </GlobalCard>
            </Grid>

            <Grid item xs={12} sm={12} md={5}>
              <GlobalCard height="100%">
                {/* Header */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    py: 2,
                    borderRadius: 2,
                    mb: 2,
                    background: "linear-gradient(to right, #f3e6f9, #e6f0ff)",
                  }}
                >
                  <Box height={30} width={30}>
                    <img
                      src="/newdashboard/Grades/mynaui_leaves-solid.png"
                      style={{ color: "#91288c", mr: 1 }}
                    />
                  </Box>
                  <Typography
                    ml={1}
                    sx={{
                      fontFamily: "Inter",
                      fontSize: "20px",
                      fontWeight: 400,

                      fontStyle: "normal",

                      color: "#9D0385",
                    }}
                  >
                    {classDetails?.growListHeading}
                  </Typography>
                </Box>

                {/* List Items */}

                <List>
                  {classDetails?.growList?.map((item) => (
                    <ListItem sx={{ py: 0.5 }}>
                      <Box height={20} width={20} mr={2}>
                        {" "}
                        {item?.icon}
                      </Box>

                      <ListItemText
                        primary={item?.title}
                        primaryTypographyProps={{
                          sx: {
                            fontFamily: "Inter",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontSize: "16px",
                            color: "#444444 !important",
                          },
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
              </GlobalCard>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
